// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle-" + {"vendors-node_modules_qrcodejs2_qrcode_js":"cd2d2263c39aed17782b","src_js_account_configureAuthenticator_js":"f2a482eebecf553610e0"}[chunkId] + ".js";
};